module.exports = {
	"textures": [
		{
			"image": "SpriteSheet.png",
			"format": "RGBA8888",
			"size": {
				"w": 2031,
				"h": 2047
			},
			"scale": 1,
			"frames": [
				{
					"filename": "board_button_2nd12_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 512,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 510,
						"h": 108
					},
					"frame": {
						"x": 1,
						"y": 1,
						"w": 510,
						"h": 108
					}
				},
				{
					"filename": "board_button_1st12.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 512,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 510,
						"h": 107
					},
					"frame": {
						"x": 1,
						"y": 111,
						"w": 510,
						"h": 107
					}
				},
				{
					"filename": "board_button_1st12_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 512,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 510,
						"h": 107
					},
					"frame": {
						"x": 513,
						"y": 1,
						"w": 510,
						"h": 107
					}
				},
				{
					"filename": "board_button_1st12_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 512,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 510,
						"h": 107
					},
					"frame": {
						"x": 1,
						"y": 220,
						"w": 510,
						"h": 107
					}
				},
				{
					"filename": "board_button_2nd12.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 512,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 510,
						"h": 107
					},
					"frame": {
						"x": 513,
						"y": 110,
						"w": 510,
						"h": 107
					}
				},
				{
					"filename": "board_button_2nd12_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 512,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 510,
						"h": 107
					},
					"frame": {
						"x": 1025,
						"y": 1,
						"w": 510,
						"h": 107
					}
				},
				{
					"filename": "board_button_3rd12.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 512,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 510,
						"h": 107
					},
					"frame": {
						"x": 1,
						"y": 329,
						"w": 510,
						"h": 107
					}
				},
				{
					"filename": "board_button_3rd12_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 512,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 510,
						"h": 107
					},
					"frame": {
						"x": 513,
						"y": 219,
						"w": 510,
						"h": 107
					}
				},
				{
					"filename": "board_button_3rd12_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 512,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 510,
						"h": 107
					},
					"frame": {
						"x": 1025,
						"y": 110,
						"w": 510,
						"h": 107
					}
				},
				{
					"filename": "board_button_0.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 123,
						"h": 322
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 123,
						"h": 322
					},
					"frame": {
						"x": 1,
						"y": 438,
						"w": 123,
						"h": 322
					}
				},
				{
					"filename": "board_button_0_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 123,
						"h": 322
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 123,
						"h": 322
					},
					"frame": {
						"x": 1,
						"y": 762,
						"w": 123,
						"h": 322
					}
				},
				{
					"filename": "board_button_0_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 123,
						"h": 322
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 123,
						"h": 322
					},
					"frame": {
						"x": 126,
						"y": 438,
						"w": 123,
						"h": 322
					}
				},
				{
					"filename": "board_button_black_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 257,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 0,
						"w": 253,
						"h": 109
					},
					"frame": {
						"x": 1537,
						"y": 1,
						"w": 253,
						"h": 109
					}
				},
				{
					"filename": "board_button_red_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 257,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 3,
						"y": 0,
						"w": 253,
						"h": 109
					},
					"frame": {
						"x": 251,
						"y": 438,
						"w": 253,
						"h": 109
					}
				},
				{
					"filename": "board_button_19to36_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 257,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 3,
						"y": 1,
						"w": 253,
						"h": 108
					},
					"frame": {
						"x": 513,
						"y": 328,
						"w": 253,
						"h": 108
					}
				},
				{
					"filename": "board_button_1to18_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 257,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 1,
						"w": 253,
						"h": 108
					},
					"frame": {
						"x": 251,
						"y": 549,
						"w": 253,
						"h": 108
					}
				},
				{
					"filename": "board_button_black_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 257,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 253,
						"h": 108
					},
					"frame": {
						"x": 506,
						"y": 438,
						"w": 253,
						"h": 108
					}
				},
				{
					"filename": "board_button_even_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 257,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 253,
						"h": 108
					},
					"frame": {
						"x": 768,
						"y": 328,
						"w": 253,
						"h": 108
					}
				},
				{
					"filename": "board_button_odd_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 257,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 2,
						"y": 1,
						"w": 253,
						"h": 108
					},
					"frame": {
						"x": 506,
						"y": 548,
						"w": 253,
						"h": 108
					}
				},
				{
					"filename": "board_button_19to36.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 257,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 3,
						"y": 1,
						"w": 253,
						"h": 107
					},
					"frame": {
						"x": 1025,
						"y": 219,
						"w": 253,
						"h": 107
					}
				},
				{
					"filename": "board_button_19to36_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 257,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 3,
						"y": 1,
						"w": 253,
						"h": 107
					},
					"frame": {
						"x": 761,
						"y": 438,
						"w": 253,
						"h": 107
					}
				},
				{
					"filename": "board_button_black.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 257,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 253,
						"h": 107
					},
					"frame": {
						"x": 1023,
						"y": 328,
						"w": 253,
						"h": 107
					}
				},
				{
					"filename": "board_button_even.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 257,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 253,
						"h": 107
					},
					"frame": {
						"x": 1280,
						"y": 219,
						"w": 253,
						"h": 107
					}
				},
				{
					"filename": "board_button_even_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 257,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 253,
						"h": 107
					},
					"frame": {
						"x": 761,
						"y": 547,
						"w": 253,
						"h": 107
					}
				},
				{
					"filename": "board_button_1to18.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 257,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 252,
						"h": 107
					},
					"frame": {
						"x": 1278,
						"y": 328,
						"w": 252,
						"h": 107
					}
				},
				{
					"filename": "board_button_1to18_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 257,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 252,
						"h": 107
					},
					"frame": {
						"x": 1537,
						"y": 112,
						"w": 252,
						"h": 107
					}
				},
				{
					"filename": "board_button_odd.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 257,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 3,
						"y": 1,
						"w": 252,
						"h": 107
					},
					"frame": {
						"x": 1535,
						"y": 221,
						"w": 252,
						"h": 107
					}
				},
				{
					"filename": "board_button_odd_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 257,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 3,
						"y": 1,
						"w": 252,
						"h": 107
					},
					"frame": {
						"x": 1532,
						"y": 330,
						"w": 252,
						"h": 107
					}
				},
				{
					"filename": "board_button_red.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 257,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 3,
						"y": 1,
						"w": 252,
						"h": 107
					},
					"frame": {
						"x": 251,
						"y": 659,
						"w": 252,
						"h": 107
					}
				},
				{
					"filename": "board_button_00_0.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 123,
						"h": 161
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 1,
						"w": 123,
						"h": 160
					},
					"frame": {
						"x": 126,
						"y": 762,
						"w": 123,
						"h": 160
					}
				},
				{
					"filename": "board_button_red_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 257,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 3,
						"y": 1,
						"w": 252,
						"h": 108
					},
					"frame": {
						"x": 251,
						"y": 768,
						"w": 252,
						"h": 108
					}
				},
				{
					"filename": "board_button_00_0_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 123,
						"h": 161
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 1,
						"w": 123,
						"h": 160
					},
					"frame": {
						"x": 1,
						"y": 1086,
						"w": 123,
						"h": 160
					}
				},
				{
					"filename": "board_button_00_0_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 123,
						"h": 161
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 1,
						"w": 123,
						"h": 160
					},
					"frame": {
						"x": 126,
						"y": 924,
						"w": 123,
						"h": 160
					}
				},
				{
					"filename": "board_button_00_00.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 123,
						"h": 161
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 123,
						"h": 159
					},
					"frame": {
						"x": 251,
						"y": 878,
						"w": 123,
						"h": 159
					}
				},
				{
					"filename": "board_button_00_00_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 123,
						"h": 161
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 123,
						"h": 159
					},
					"frame": {
						"x": 1,
						"y": 1248,
						"w": 123,
						"h": 159
					}
				},
				{
					"filename": "board_button_00_00_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 123,
						"h": 161
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 123,
						"h": 159
					},
					"frame": {
						"x": 126,
						"y": 1086,
						"w": 123,
						"h": 159
					}
				},
				{
					"filename": "fullscreen.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 125,
						"h": 125
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 125,
						"h": 125
					},
					"frame": {
						"x": 376,
						"y": 878,
						"w": 125,
						"h": 125
					}
				},
				{
					"filename": "statistics_icon.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 125,
						"h": 125
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 125,
						"h": 125
					},
					"frame": {
						"x": 251,
						"y": 1039,
						"w": 125,
						"h": 125
					}
				},
				{
					"filename": "Logout_Button.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 125,
						"h": 123
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 125,
						"h": 123
					},
					"frame": {
						"x": 1,
						"y": 1409,
						"w": 125,
						"h": 123
					}
				},
				{
					"filename": "Preset_Button_1.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 130,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 130,
						"h": 110
					},
					"frame": {
						"x": 1792,
						"y": 1,
						"w": 130,
						"h": 110
					}
				},
				{
					"filename": "chip1_D.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 106,
						"h": 106
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 106,
						"h": 106
					},
					"frame": {
						"x": 1924,
						"y": 1,
						"w": 106,
						"h": 106
					}
				},
				{
					"filename": "Preset_Button_1_Disabled.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 128,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 128,
						"h": 110
					},
					"frame": {
						"x": 1,
						"y": 1534,
						"w": 128,
						"h": 110
					}
				},
				{
					"filename": "Preset_Button_1_Hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 128,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 128,
						"h": 110
					},
					"frame": {
						"x": 1,
						"y": 1646,
						"w": 128,
						"h": 110
					}
				},
				{
					"filename": "Preset_Button_2_Disabled.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 129,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 129,
						"h": 110
					},
					"frame": {
						"x": 1,
						"y": 1758,
						"w": 129,
						"h": 110
					}
				},
				{
					"filename": "Preset_Button_2_Hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 129,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 129,
						"h": 110
					},
					"frame": {
						"x": 1,
						"y": 1870,
						"w": 129,
						"h": 110
					}
				},
				{
					"filename": "Preset_Button_4.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 129,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 129,
						"h": 110
					},
					"frame": {
						"x": 1791,
						"y": 113,
						"w": 129,
						"h": 110
					}
				},
				{
					"filename": "button_neighbour_bet_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 111
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 111
					},
					"frame": {
						"x": 126,
						"y": 1247,
						"w": 124,
						"h": 111
					}
				},
				{
					"filename": "Preset_Button_4_Disabled.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 129,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 129,
						"h": 110
					},
					"frame": {
						"x": 1789,
						"y": 225,
						"w": 129,
						"h": 110
					}
				},
				{
					"filename": "Preset_Button_4_Hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 129,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 129,
						"h": 110
					},
					"frame": {
						"x": 1786,
						"y": 337,
						"w": 129,
						"h": 110
					}
				},
				{
					"filename": "chip1_N.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 106,
						"h": 106
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 106,
						"h": 106
					},
					"frame": {
						"x": 1924,
						"y": 109,
						"w": 106,
						"h": 106
					}
				},
				{
					"filename": "Preset_Button_2.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 127,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 127,
						"h": 110
					},
					"frame": {
						"x": 378,
						"y": 1005,
						"w": 127,
						"h": 110
					}
				},
				{
					"filename": "Preset_Button_3.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 128,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 128,
						"h": 110
					},
					"frame": {
						"x": 128,
						"y": 1360,
						"w": 128,
						"h": 110
					}
				},
				{
					"filename": "Preset_Button_3_Disabled.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 128,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 128,
						"h": 110
					},
					"frame": {
						"x": 378,
						"y": 1117,
						"w": 128,
						"h": 110
					}
				},
				{
					"filename": "board_button_1.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 252,
						"y": 1166,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "Preset_Button_3_Hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 128,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 128,
						"h": 110
					},
					"frame": {
						"x": 131,
						"y": 1472,
						"w": 128,
						"h": 110
					}
				},
				{
					"filename": "Preset_Button_5.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 128,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 128,
						"h": 110
					},
					"frame": {
						"x": 131,
						"y": 1584,
						"w": 128,
						"h": 110
					}
				},
				{
					"filename": "Preset_Button_5_Disabled.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 128,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 128,
						"h": 110
					},
					"frame": {
						"x": 132,
						"y": 1696,
						"w": 128,
						"h": 110
					}
				},
				{
					"filename": "Preset_Button_5_Hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 128,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 128,
						"h": 110
					},
					"frame": {
						"x": 132,
						"y": 1808,
						"w": 128,
						"h": 110
					}
				},
				{
					"filename": "Preset_Button_6.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 129,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 129,
						"h": 110
					},
					"frame": {
						"x": 132,
						"y": 1920,
						"w": 129,
						"h": 110
					}
				},
				{
					"filename": "Preset_Button_6_Disabled.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 129,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 129,
						"h": 110
					},
					"frame": {
						"x": 378,
						"y": 1229,
						"w": 129,
						"h": 110
					}
				},
				{
					"filename": "button_oval.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 122,
						"h": 50
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 122,
						"h": 50
					},
					"frame": {
						"x": 1,
						"y": 1982,
						"w": 122,
						"h": 50
					}
				},
				{
					"filename": "button_oval_disabled.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 122,
						"h": 50
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 122,
						"h": 50
					},
					"frame": {
						"x": 252,
						"y": 1275,
						"w": 122,
						"h": 50
					}
				},
				{
					"filename": "question_mark_icon.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 123
					},
					"spriteSourceSize": {
						"x": 15,
						"y": 0,
						"w": 94,
						"h": 123
					},
					"frame": {
						"x": 258,
						"y": 1327,
						"w": 94,
						"h": 123
					}
				},
				{
					"filename": "Preset_Button_6_Hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 129,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 129,
						"h": 110
					},
					"frame": {
						"x": 354,
						"y": 1341,
						"w": 129,
						"h": 110
					}
				},
				{
					"filename": "chipX_multiple_5_N.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 106,
						"h": 106
					},
					"spriteSourceSize": {
						"x": 11,
						"y": 11,
						"w": 84,
						"h": 84
					},
					"frame": {
						"x": 261,
						"y": 1452,
						"w": 84,
						"h": 84
					}
				},
				{
					"filename": "Preset_Button_8.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 129,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 129,
						"h": 110
					},
					"frame": {
						"x": 347,
						"y": 1453,
						"w": 129,
						"h": 110
					}
				},
				{
					"filename": "Preset_Button_8_Disabled.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 129,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 129,
						"h": 110
					},
					"frame": {
						"x": 261,
						"y": 1565,
						"w": 129,
						"h": 110
					}
				},
				{
					"filename": "Preset_Button_7.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 128,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 128,
						"h": 110
					},
					"frame": {
						"x": 262,
						"y": 1677,
						"w": 128,
						"h": 110
					}
				},
				{
					"filename": "Preset_Button_7_Disabled.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 128,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 128,
						"h": 110
					},
					"frame": {
						"x": 262,
						"y": 1789,
						"w": 128,
						"h": 110
					}
				},
				{
					"filename": "Preset_Button_7_Hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 128,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 128,
						"h": 110
					},
					"frame": {
						"x": 263,
						"y": 1901,
						"w": 128,
						"h": 110
					}
				},
				{
					"filename": "Preset_Button_8_Hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 129,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 129,
						"h": 110
					},
					"frame": {
						"x": 392,
						"y": 1565,
						"w": 129,
						"h": 110
					}
				},
				{
					"filename": "button_wide_bet_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 128,
						"h": 108
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 128,
						"h": 108
					},
					"frame": {
						"x": 392,
						"y": 1677,
						"w": 128,
						"h": 108
					}
				},
				{
					"filename": "preset_buttons_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 128,
						"h": 108
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 128,
						"h": 108
					},
					"frame": {
						"x": 392,
						"y": 1787,
						"w": 128,
						"h": 108
					}
				},
				{
					"filename": "Track_Black_Button_Disabled.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 127,
						"h": 108
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 127,
						"h": 108
					},
					"frame": {
						"x": 393,
						"y": 1897,
						"w": 127,
						"h": 108
					}
				},
				{
					"filename": "Track_Red_Button_Disabled.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 127,
						"h": 108
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 127,
						"h": 108
					},
					"frame": {
						"x": 485,
						"y": 1341,
						"w": 127,
						"h": 108
					}
				},
				{
					"filename": "Track_Black_Button.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 127,
						"h": 108
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 126,
						"h": 107
					},
					"frame": {
						"x": 761,
						"y": 656,
						"w": 126,
						"h": 107
					}
				},
				{
					"filename": "Track_Black_Button_Hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 127,
						"h": 108
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 126,
						"h": 107
					},
					"frame": {
						"x": 889,
						"y": 656,
						"w": 126,
						"h": 107
					}
				},
				{
					"filename": "Track_Red_Button.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 127,
						"h": 108
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 126,
						"h": 107
					},
					"frame": {
						"x": 485,
						"y": 1451,
						"w": 126,
						"h": 107
					}
				},
				{
					"filename": "Track_Red_Button_Hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 127,
						"h": 108
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 126,
						"h": 107
					},
					"frame": {
						"x": 523,
						"y": 1560,
						"w": 126,
						"h": 107
					}
				},
				{
					"filename": "board_button_10.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 613,
						"y": 1451,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_10_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 651,
						"y": 1560,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_12to1.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 128,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 126,
						"h": 107
					},
					"frame": {
						"x": 523,
						"y": 1669,
						"w": 126,
						"h": 107
					}
				},
				{
					"filename": "board_button_12to1_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 128,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 126,
						"h": 107
					},
					"frame": {
						"x": 522,
						"y": 1778,
						"w": 126,
						"h": 107
					}
				},
				{
					"filename": "board_button_12to1_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 128,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 126,
						"h": 107
					},
					"frame": {
						"x": 522,
						"y": 1887,
						"w": 126,
						"h": 107
					}
				},
				{
					"filename": "button_oval_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 122,
						"h": 50
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 122,
						"h": 50
					},
					"frame": {
						"x": 522,
						"y": 1996,
						"w": 122,
						"h": 50
					}
				},
				{
					"filename": "board_button_10_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 651,
						"y": 1669,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_22to1.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 128,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 126,
						"h": 107
					},
					"frame": {
						"x": 650,
						"y": 1778,
						"w": 126,
						"h": 107
					}
				},
				{
					"filename": "board_button_22to1_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 128,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 126,
						"h": 107
					},
					"frame": {
						"x": 650,
						"y": 1887,
						"w": 126,
						"h": 107
					}
				},
				{
					"filename": "chips0.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 100,
						"h": 50
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 100,
						"h": 50
					},
					"frame": {
						"x": 646,
						"y": 1996,
						"w": 100,
						"h": 50
					}
				},
				{
					"filename": "chips1.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 100,
						"h": 50
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 100,
						"h": 50
					},
					"frame": {
						"x": 748,
						"y": 1996,
						"w": 100,
						"h": 50
					}
				},
				{
					"filename": "board_button_22to1_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 128,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 126,
						"h": 107
					},
					"frame": {
						"x": 1023,
						"y": 437,
						"w": 126,
						"h": 107
					}
				},
				{
					"filename": "board_button_32to1.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 128,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 126,
						"h": 107
					},
					"frame": {
						"x": 1151,
						"y": 437,
						"w": 126,
						"h": 107
					}
				},
				{
					"filename": "board_button_32to1_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 128,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 126,
						"h": 107
					},
					"frame": {
						"x": 1279,
						"y": 437,
						"w": 126,
						"h": 107
					}
				},
				{
					"filename": "board_button_4.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 2,
						"y": 1,
						"w": 123,
						"h": 107
					},
					"frame": {
						"x": 1407,
						"y": 437,
						"w": 123,
						"h": 107
					}
				},
				{
					"filename": "board_button_32to1_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 128,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 126,
						"h": 107
					},
					"frame": {
						"x": 1532,
						"y": 439,
						"w": 126,
						"h": 107
					}
				},
				{
					"filename": "board_button_11.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1660,
						"y": 439,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_25_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 1,
						"w": 125,
						"h": 107
					},
					"frame": {
						"x": 1016,
						"y": 546,
						"w": 125,
						"h": 107
					}
				},
				{
					"filename": "board_button_26_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 1,
						"w": 125,
						"h": 107
					},
					"frame": {
						"x": 1143,
						"y": 546,
						"w": 125,
						"h": 107
					}
				},
				{
					"filename": "board_button_27_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 1,
						"w": 125,
						"h": 107
					},
					"frame": {
						"x": 1270,
						"y": 546,
						"w": 125,
						"h": 107
					}
				},
				{
					"filename": "board_button_11_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1397,
						"y": 546,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_11_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1017,
						"y": 655,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_12.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1143,
						"y": 655,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_12_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1269,
						"y": 655,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_12_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1395,
						"y": 655,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_13.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1786,
						"y": 449,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_13_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1523,
						"y": 548,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_13_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1649,
						"y": 548,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_14.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1521,
						"y": 657,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_14_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1647,
						"y": 657,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_14_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1775,
						"y": 558,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_15.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1773,
						"y": 667,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_15_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 506,
						"y": 658,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_15_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 632,
						"y": 658,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_16.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 505,
						"y": 767,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_16_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 631,
						"y": 767,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_16_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 505,
						"y": 876,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_17.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 631,
						"y": 876,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_17_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 507,
						"y": 985,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_17_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 633,
						"y": 985,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_18.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 508,
						"y": 1094,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_18_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 634,
						"y": 1094,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_18_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 509,
						"y": 1203,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_19.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 635,
						"y": 1203,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_19_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 614,
						"y": 1312,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_19_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 740,
						"y": 1312,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_1_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 739,
						"y": 1421,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_1_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 777,
						"y": 1530,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_2.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 777,
						"y": 1639,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_20.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 778,
						"y": 1748,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_20_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 778,
						"y": 1857,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_20_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 865,
						"y": 1421,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_21.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 903,
						"y": 1530,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_21_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 903,
						"y": 1639,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_21_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 904,
						"y": 1748,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_22.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 904,
						"y": 1857,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_22_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1017,
						"y": 764,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_22_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1143,
						"y": 764,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_23.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1269,
						"y": 764,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_23_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1395,
						"y": 764,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_23_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1521,
						"y": 766,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_24.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1647,
						"y": 766,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_24_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1773,
						"y": 776,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_24_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 761,
						"y": 765,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_25.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 887,
						"y": 765,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_25_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 757,
						"y": 874,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_26.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 883,
						"y": 874,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_26_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 759,
						"y": 983,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_27.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 885,
						"y": 983,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_27_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 760,
						"y": 1092,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_28.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 886,
						"y": 1092,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_28_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 761,
						"y": 1201,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_28_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 887,
						"y": 1201,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_29.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 866,
						"y": 1310,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_29_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 992,
						"y": 1310,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_29_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 991,
						"y": 1419,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_2_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1029,
						"y": 1528,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_2_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1029,
						"y": 1637,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_3.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1030,
						"y": 1746,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_30.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1030,
						"y": 1855,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_30_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1117,
						"y": 1419,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_30_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1155,
						"y": 1528,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_31.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1155,
						"y": 1637,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_31_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1156,
						"y": 1746,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_31_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1156,
						"y": 1855,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_32.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1118,
						"y": 873,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_32_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1244,
						"y": 873,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_32_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1370,
						"y": 873,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_33.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1496,
						"y": 875,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_33_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1622,
						"y": 875,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_33_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1748,
						"y": 885,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_34.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1874,
						"y": 885,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_34_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1011,
						"y": 982,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_34_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1137,
						"y": 982,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_35.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1263,
						"y": 982,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_35_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1012,
						"y": 1091,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_35_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1138,
						"y": 1091,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_36.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1013,
						"y": 1200,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_36_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1264,
						"y": 1091,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_36_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1139,
						"y": 1200,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_3_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1118,
						"y": 1309,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_3_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1265,
						"y": 1200,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_4_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1244,
						"y": 1309,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_5_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1243,
						"y": 1418,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "chip2_D.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 106,
						"h": 106
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 106,
						"h": 106
					},
					"frame": {
						"x": 1009,
						"y": 874,
						"w": 106,
						"h": 106
					}
				},
				{
					"filename": "chipX_new_5_N_V2.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 106,
						"h": 106
					},
					"spriteSourceSize": {
						"x": 2,
						"y": 2,
						"w": 102,
						"h": 102
					},
					"frame": {
						"x": 1389,
						"y": 982,
						"w": 102,
						"h": 102
					}
				},
				{
					"filename": "board_button_6_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1493,
						"y": 984,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_7.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1619,
						"y": 984,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_7_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1745,
						"y": 994,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_7_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1871,
						"y": 994,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "chipX_new_5_D_V2.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 106,
						"h": 106
					},
					"spriteSourceSize": {
						"x": 3,
						"y": 3,
						"w": 100,
						"h": 100
					},
					"frame": {
						"x": 1390,
						"y": 1086,
						"w": 100,
						"h": 100
					}
				},
				{
					"filename": "board_button_8.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1492,
						"y": 1093,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_8_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1618,
						"y": 1093,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_8_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1744,
						"y": 1103,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_9.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1870,
						"y": 1103,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "statistics_icon_small.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 125
					},
					"spriteSourceSize": {
						"x": 13,
						"y": 13,
						"w": 99,
						"h": 99
					},
					"frame": {
						"x": 1391,
						"y": 1188,
						"w": 99,
						"h": 99
					}
				},
				{
					"filename": "board_button_9_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1492,
						"y": 1202,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "board_button_9_win.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 124,
						"h": 107
					},
					"frame": {
						"x": 1618,
						"y": 1202,
						"w": 124,
						"h": 107
					}
				},
				{
					"filename": "button_neighbour_bet.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 105
					},
					"frame": {
						"x": 1744,
						"y": 1212,
						"w": 124,
						"h": 105
					}
				},
				{
					"filename": "00_history_display.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 2,
						"y": 2,
						"w": 123,
						"h": 105
					},
					"frame": {
						"x": 1870,
						"y": 1212,
						"w": 123,
						"h": 105
					}
				},
				{
					"filename": "board_button_4_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 2,
						"y": 1,
						"w": 123,
						"h": 107
					},
					"frame": {
						"x": 1281,
						"y": 1527,
						"w": 123,
						"h": 107
					}
				},
				{
					"filename": "board_button_5.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 2,
						"y": 1,
						"w": 123,
						"h": 107
					},
					"frame": {
						"x": 1281,
						"y": 1636,
						"w": 123,
						"h": 107
					}
				},
				{
					"filename": "board_button_5_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 2,
						"y": 1,
						"w": 123,
						"h": 107
					},
					"frame": {
						"x": 1282,
						"y": 1745,
						"w": 123,
						"h": 107
					}
				},
				{
					"filename": "board_button_6.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 2,
						"y": 1,
						"w": 123,
						"h": 107
					},
					"frame": {
						"x": 1282,
						"y": 1854,
						"w": 123,
						"h": 107
					}
				},
				{
					"filename": "board_button_6_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 2,
						"y": 1,
						"w": 123,
						"h": 107
					},
					"frame": {
						"x": 1369,
						"y": 1418,
						"w": 123,
						"h": 107
					}
				},
				{
					"filename": "0_history_display.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 109
					},
					"spriteSourceSize": {
						"x": 2,
						"y": 2,
						"w": 123,
						"h": 105
					},
					"frame": {
						"x": 1370,
						"y": 1311,
						"w": 123,
						"h": 105
					}
				},
				{
					"filename": "button_wide_bet.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 124,
						"h": 104
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 124,
						"h": 104
					},
					"frame": {
						"x": 1495,
						"y": 1311,
						"w": 124,
						"h": 104
					}
				},
				{
					"filename": "Speaker_On_Icon.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 125
					},
					"spriteSourceSize": {
						"x": 4,
						"y": 17,
						"w": 119,
						"h": 93
					},
					"frame": {
						"x": 1621,
						"y": 1311,
						"w": 119,
						"h": 93
					}
				},
				{
					"filename": "button_bet_mode.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 123,
						"h": 103
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 123,
						"h": 103
					},
					"frame": {
						"x": 1742,
						"y": 1319,
						"w": 123,
						"h": 103
					}
				},
				{
					"filename": "button_bet_mode_paint.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 123,
						"h": 103
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 123,
						"h": 103
					},
					"frame": {
						"x": 1867,
						"y": 1319,
						"w": 123,
						"h": 103
					}
				},
				{
					"filename": "chip2_N.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 106,
						"h": 106
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 106,
						"h": 106
					},
					"frame": {
						"x": 1406,
						"y": 1527,
						"w": 106,
						"h": 106
					}
				},
				{
					"filename": "chip3_D.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 106,
						"h": 106
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 106,
						"h": 106
					},
					"frame": {
						"x": 1406,
						"y": 1635,
						"w": 106,
						"h": 106
					}
				},
				{
					"filename": "chip3_N.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 106,
						"h": 106
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 106,
						"h": 106
					},
					"frame": {
						"x": 1407,
						"y": 1743,
						"w": 106,
						"h": 106
					}
				},
				{
					"filename": "chip4_D.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 106,
						"h": 106
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 106,
						"h": 106
					},
					"frame": {
						"x": 1407,
						"y": 1851,
						"w": 106,
						"h": 106
					}
				},
				{
					"filename": "Speaker_Off_Icon.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 125
					},
					"spriteSourceSize": {
						"x": 4,
						"y": 17,
						"w": 116,
						"h": 93
					},
					"frame": {
						"x": 1621,
						"y": 1406,
						"w": 116,
						"h": 93
					}
				},
				{
					"filename": "button_big_series.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 123,
						"h": 103
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 123,
						"h": 103
					},
					"frame": {
						"x": 1739,
						"y": 1424,
						"w": 123,
						"h": 103
					}
				},
				{
					"filename": "button_board.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 123,
						"h": 103
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 123,
						"h": 103
					},
					"frame": {
						"x": 1864,
						"y": 1424,
						"w": 123,
						"h": 103
					}
				},
				{
					"filename": "button_board_disabled.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 123,
						"h": 103
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 123,
						"h": 103
					},
					"frame": {
						"x": 1495,
						"y": 1417,
						"w": 123,
						"h": 103
					}
				},
				{
					"filename": "chip4_N.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 106,
						"h": 106
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 106,
						"h": 106
					},
					"frame": {
						"x": 1514,
						"y": 1522,
						"w": 106,
						"h": 106
					}
				},
				{
					"filename": "chip5_D.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 106,
						"h": 106
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 106,
						"h": 106
					},
					"frame": {
						"x": 1514,
						"y": 1630,
						"w": 106,
						"h": 106
					}
				},
				{
					"filename": "chip5_N.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 106,
						"h": 106
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 106,
						"h": 106
					},
					"frame": {
						"x": 1515,
						"y": 1738,
						"w": 106,
						"h": 106
					}
				},
				{
					"filename": "button_board_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 123,
						"h": 103
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 123,
						"h": 103
					},
					"frame": {
						"x": 1515,
						"y": 1846,
						"w": 123,
						"h": 103
					}
				},
				{
					"filename": "history_small.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 125,
						"h": 125
					},
					"spriteSourceSize": {
						"x": 5,
						"y": 15,
						"w": 111,
						"h": 95
					},
					"frame": {
						"x": 1515,
						"y": 1951,
						"w": 111,
						"h": 95
					}
				},
				{
					"filename": "play_button.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 109,
						"h": 89
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 109,
						"h": 89
					},
					"frame": {
						"x": 1622,
						"y": 1501,
						"w": 109,
						"h": 89
					}
				},
				{
					"filename": "button_neighbour_bet_disabled.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 123,
						"h": 103
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 123,
						"h": 103
					},
					"frame": {
						"x": 1622,
						"y": 1592,
						"w": 123,
						"h": 103
					}
				},
				{
					"filename": "button_presets.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 123,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 2,
						"w": 123,
						"h": 103
					},
					"frame": {
						"x": 1623,
						"y": 1697,
						"w": 123,
						"h": 103
					}
				},
				{
					"filename": "button_presets_disabled.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 123,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 2,
						"w": 123,
						"h": 103
					},
					"frame": {
						"x": 1640,
						"y": 1802,
						"w": 123,
						"h": 103
					}
				},
				{
					"filename": "button_presets_hover.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 123,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 2,
						"w": 123,
						"h": 103
					},
					"frame": {
						"x": 1640,
						"y": 1907,
						"w": 123,
						"h": 103
					}
				},
				{
					"filename": "button_repeat_bets.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 123,
						"h": 103
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 123,
						"h": 103
					},
					"frame": {
						"x": 1747,
						"y": 1529,
						"w": 123,
						"h": 103
					}
				},
				{
					"filename": "button_repeat_bets_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 123,
						"h": 103
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 123,
						"h": 103
					},
					"frame": {
						"x": 1872,
						"y": 1529,
						"w": 123,
						"h": 103
					}
				},
				{
					"filename": "button_track.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 123,
						"h": 103
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 123,
						"h": 103
					},
					"frame": {
						"x": 1748,
						"y": 1634,
						"w": 123,
						"h": 103
					}
				},
				{
					"filename": "button_track_disabled.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 123,
						"h": 103
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 123,
						"h": 103
					},
					"frame": {
						"x": 1873,
						"y": 1634,
						"w": 123,
						"h": 103
					}
				},
				{
					"filename": "button_track_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 123,
						"h": 103
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 123,
						"h": 103
					},
					"frame": {
						"x": 1765,
						"y": 1739,
						"w": 123,
						"h": 103
					}
				},
				{
					"filename": "button_undo.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 123,
						"h": 103
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 123,
						"h": 103
					},
					"frame": {
						"x": 1765,
						"y": 1844,
						"w": 123,
						"h": 103
					}
				},
				{
					"filename": "chipX_new_5_D.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 106,
						"h": 106
					},
					"spriteSourceSize": {
						"x": 4,
						"y": 5,
						"w": 97,
						"h": 97
					},
					"frame": {
						"x": 1765,
						"y": 1949,
						"w": 97,
						"h": 97
					}
				},
				{
					"filename": "chipX_new_5_N.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 106,
						"h": 106
					},
					"spriteSourceSize": {
						"x": 4,
						"y": 5,
						"w": 97,
						"h": 97
					},
					"frame": {
						"x": 1864,
						"y": 1949,
						"w": 97,
						"h": 97
					}
				},
				{
					"filename": "button_undo_disabled.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 123,
						"h": 103
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 123,
						"h": 103
					},
					"frame": {
						"x": 1890,
						"y": 1739,
						"w": 123,
						"h": 103
					}
				},
				{
					"filename": "button_undo_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 123,
						"h": 103
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 123,
						"h": 103
					},
					"frame": {
						"x": 1890,
						"y": 1844,
						"w": 123,
						"h": 103
					}
				},
				{
					"filename": "chips2.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 100,
						"h": 50
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 100,
						"h": 50
					},
					"frame": {
						"x": 850,
						"y": 1966,
						"w": 100,
						"h": 50
					}
				},
				{
					"filename": "chips3.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 100,
						"h": 50
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 100,
						"h": 50
					},
					"frame": {
						"x": 952,
						"y": 1966,
						"w": 100,
						"h": 50
					}
				},
				{
					"filename": "chips4.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 100,
						"h": 50
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 100,
						"h": 50
					},
					"frame": {
						"x": 1054,
						"y": 1964,
						"w": 100,
						"h": 50
					}
				},
				{
					"filename": "chips5.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 100,
						"h": 50
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 100,
						"h": 50
					},
					"frame": {
						"x": 1156,
						"y": 1964,
						"w": 100,
						"h": 50
					}
				},
				{
					"filename": "button_wide_bet_disabled.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 123,
						"h": 103
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 123,
						"h": 103
					},
					"frame": {
						"x": 1901,
						"y": 558,
						"w": 123,
						"h": 103
					}
				},
				{
					"filename": "chipX_new_4_N.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 106,
						"h": 106
					},
					"spriteSourceSize": {
						"x": 4,
						"y": 4,
						"w": 98,
						"h": 98
					},
					"frame": {
						"x": 1922,
						"y": 217,
						"w": 98,
						"h": 98
					}
				},
				{
					"filename": "chipX_D.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 95,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 92,
						"h": 97
					},
					"frame": {
						"x": 1920,
						"y": 317,
						"w": 92,
						"h": 97
					}
				},
				{
					"filename": "chipX_N.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 95,
						"h": 100
					},
					"spriteSourceSize": {
						"x": 1,
						"y": 1,
						"w": 92,
						"h": 97
					},
					"frame": {
						"x": 1917,
						"y": 416,
						"w": 92,
						"h": 97
					}
				},
				{
					"filename": "Repeat_Game_Icon.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 51,
						"h": 41
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 51,
						"h": 41
					},
					"frame": {
						"x": 1912,
						"y": 515,
						"w": 51,
						"h": 41
					}
				},
				{
					"filename": "Big_Series_Icon.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 40,
						"h": 40
					},
					"spriteSourceSize": {
						"x": 7,
						"y": 7,
						"w": 25,
						"h": 25
					},
					"frame": {
						"x": 261,
						"y": 1538,
						"w": 25,
						"h": 25
					}
				},
				{
					"filename": "Orphans_Icon.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 40,
						"h": 40
					},
					"spriteSourceSize": {
						"x": 7,
						"y": 7,
						"w": 25,
						"h": 25
					},
					"frame": {
						"x": 288,
						"y": 1538,
						"w": 25,
						"h": 25
					}
				},
				{
					"filename": "Serie_58_Icon.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 40,
						"h": 40
					},
					"spriteSourceSize": {
						"x": 7,
						"y": 7,
						"w": 25,
						"h": 25
					},
					"frame": {
						"x": 315,
						"y": 1538,
						"w": 25,
						"h": 25
					}
				},
				{
					"filename": "Zero_Game_Icon.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 40,
						"h": 40
					},
					"spriteSourceSize": {
						"x": 7,
						"y": 7,
						"w": 25,
						"h": 25
					},
					"frame": {
						"x": 509,
						"y": 1312,
						"w": 25,
						"h": 25
					}
				}
			]
		}
	],
	"meta": {
		"app": "https://www.codeandweb.com/texturepacker",
		"version": "3.0",
		"smartupdate": "$TexturePacker:SmartUpdate:495ed115b0266d2bb132fa144afc56fd:09828b744dd54492402ca31519ad9eeb:160eb6758fe4007ba8592b420f92bb0b$"
	}
};